import { GroupConfigurationCategory } from '@/modules/group/modules/groups/domain/models/GroupConfigurationCategory'

import { axios, Response } from '../index'

export type Invite = {
  groupInfoSummary: GroupInfoSummary
  groupInviteId: string
  whoSentInvite: WhoSentInvite
  whoReceivedInvite: WhoReceivedInvite
  isAccepted: boolean
}

export type GroupInfoSummary = {
  groupId: string
  groupName: string
  imageUrl: string
  headerUrl: string
  groupSendPermission: string
  groupVisibility: string
  groupCategory: GroupConfigurationCategory
}

export type WhoSentInvite = {
  username: string
  avatarUrl: string
}

export type WhoReceivedInvite = {
  username: string
  avatarUrl: string
}

const getPersonaInvitations = (personaId: string): Response<Invite[]> => {
  return axios.get(`/v1/personas/${personaId}/invitations`)
}

export default getPersonaInvitations
